/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  trackShortTermExternalLinkClick
 */

import { selectFilters } from '@zcode-ui/filters'
import { getUser } from '@zcode-ui/web-zumper-global-state'
import Marketing from '@zcode/nr/es/shared/utils/marketing'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import type { Dispatch } from 'redux'
import type { GetState } from '../../../modules/types'

export const trackShortTermExternalLinkClick =
  (entity: MaybeEmpty<Listable> | MaybeEmptyProperty) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)

    const { longTerm } = selectFilters(state) ?? {}
    const { buildingId, listingId } = entity
    const isShortTerm = !longTerm
    if (listingId ?? buildingId) {
      Marketing.trackViewShortTermViewDetail(buildingId, listingId, user.email, isShortTerm)
    }
  }
